import type { FC } from "react"
import type { WithCapsuleImageFragment } from "~/contentful"
import Link from "~/components/Link"
import ResponsiveContentfulImage from "~/components/ResponsiveContentfulImage"
import { ANALYTICS_EVENTS } from "~/helpers/analyticsEvents"

interface Props {
  item: WithCapsuleImageFragment
  origin: string
  sizeMobile: string
  sizeDesktop: string
  sizes?: string
  isMainContent: boolean
  shouldEagerLoad?: boolean
}

const MultiImageItem: FC<Props> = ({
  item,
  origin,
  sizeMobile,
  sizeDesktop,
  sizes,
  isMainContent,
  shouldEagerLoad = false
}) => {
  if (!item?.image?.url && !item?.imageMobile?.url) return null

  return (
    <Link
      to={item?.url}
      openInNewWindow={item?.openInNewWindow ?? false}
      className="block w-full -outline-offset-8"
      trackClick={() => ({
        event: ANALYTICS_EVENTS.IMAGE_CLICKED,
        data: {
          path: window.location.pathname,
          url: item?.url,
          title: item?.altText,
          origin
        }
      })}
    >
      <ResponsiveContentfulImage
        src={item?.image?.url ?? item?.imageMobile?.url ?? ""}
        srcMobile={item?.imageMobile?.url ?? undefined}
        sizeMobile={sizeMobile}
        sizeDesktop={sizeDesktop}
        sizes={sizes}
        width={item?.image?.width ?? item?.imageMobile?.width ?? undefined}
        height={item?.image?.height ?? item?.imageMobile?.height ?? undefined}
        className="block w-full object-cover"
        alt={item?.altText ?? ""}
        lazyLoad={!isMainContent && !shouldEagerLoad}
      />
    </Link>
  )
}

export default MultiImageItem
